import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PoStatusUpdateService } from '../../Services/job-allocation-to-vendors/po-status-update.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { Router, ActivatedRoute } from '@angular/router';
import { PagerService } from 'src/app/Services/pager.service';
import { PoStatusUpdateDetails, PoStatusUpdateFilters, UpdatedPODetails } from 'src/app/Models/job-allocation-to-vendors/po-status-update';
import { VendorFinalizationService } from 'src/app/Services/job-allocation-to-vendors/vendor-finalization.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { formatDate } from '@angular/common';
import { TimelineConfigurationService } from 'src/app/Services/admin-rights/timeline-configuration.service';
import { TimeLineConfiguration, UpdatedTimeline } from 'src/app/Models/Admin/timeline-configuration';
import { element } from 'protractor';
import { exit } from 'process';
import { forEach } from '@angular/router/src/utils/collection';
import { ToastrModule, ToastrService } from 'ngx-toastr';


export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MMM-yyyy', this.locale);;
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-timeline-setting',
  templateUrl: './timeline-setting.component.html',
  styleUrls: ['./timeline-setting.component.css'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    DatePipe
  ]
})
export class TimelineSettingComponent implements OnInit {
  loader: string = 'none';
  IsValid: boolean = true;
  timelineDetail: TimeLineConfiguration = new TimeLineConfiguration();
  mapping: any[] = [];

  constructor(private timelineConfigurationService: TimelineConfigurationService, private router: Router, private snackBar: MatSnackBarComponent,private toastr: ToastrService) { }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getTimelineConfiguration();
  }

  getTimelineConfiguration() {
    this.loader = 'block';
    this.timelineConfigurationService.getTimelineConfiguration()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.timelineDetail = resdata.data;
          this.mapping = resdata.data.mapping;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }

  getRequirementMaxYear()
  {
     return new Date().getFullYear()+1;
  }

  updateTimeline() {
    this.loader = 'block';
    let updatedTimeline: UpdatedTimeline[] = [];
    let errormessage : string;
    this.timelineDetail.details.forEach(element => {
      let sDate: string;
      let eDate: string;

      if (element.active == 1) {
        if (element.startDate.toString().includes('GMT')) {
          sDate = element.startDate.toString().replace('GMT+0530 (India Standard Time)', '').slice(4);
        }
        else {
          sDate = element.startDate;
        }
        if (element.endDate.toString().includes('GMT')) {
          eDate = element.endDate.toString().replace('GMT+0530 (India Standard Time)', '').slice(4);
        }
        else {
          eDate = element.endDate;
        }
      }
      else {
        sDate=eDate=element.startDate = element.endDate.toString();

      }
      var details = {
        ID: element.id,
        StartDate: sDate,
        EndDate: eDate
      }
      updatedTimeline.push(details);
    })


  // Code for Client Validation
   if(updatedTimeline != null && updatedTimeline.length > 0)
   {
    for (let entry of updatedTimeline) {    
      
      if(entry.ID == 24)
      {
          // Check for Requirement year
          if(entry.StartDate < "2021" || entry.StartDate  > this.getRequirementMaxYear().toString())
          {
             errormessage = 'Timeline Settings Requirement year must be from 2021 to ' + this.getRequirementMaxYear().toString();
             this.IsValid = false;
             break;
          }
      }   
      if(entry.ID == 1 || entry.ID == 3 || entry.ID == 9)
        {
            // Check for StartDate equal or greater than endDate
             if(Date.parse(entry.StartDate) >= Date.parse(entry.EndDate))
             {
                errormessage = 'Timeline Settings StartDate should not be equal or greater than EndDate.';
                this.IsValid = false;
                break;
             }
        }

        if(entry.ID == 3)
        {
           var filterdata = updatedTimeline.find(item => item.ID == 1);
           if(filterdata != null)
           {
            var AnnualRequirementSubmissionStartDate =  filterdata.StartDate;    
            
              // Check for StartDate of Approval On Requirement Start Date is equal greater than  StartDate
              if(Date.parse(entry.StartDate) < Date.parse(AnnualRequirementSubmissionStartDate))
              {
                  errormessage = 'Timeline Settings Approval On Requirement Start Date should be equal or greater than Annual Requirement Submission Start Date';
                  this.IsValid = false;
                  break;
              }
            }
        }

        if(entry.ID == 9)
        {
           var filterdata = updatedTimeline.find(item => item.ID == 3);
           if(filterdata != null)
           {
            var ApprovalOnRequirementStartDate =  filterdata.StartDate;    
            
              // Check for StartDate of Vendor Finalization Start Date is equal greater than Approval On Requirement StartDate
              if(Date.parse(entry.StartDate) < Date.parse(ApprovalOnRequirementStartDate))
              {
                  errormessage = 'Timeline Settings Vendor Finalization Start Date should be equal or greater than Annual Requirement Submission Start Date';
                  this.IsValid = false;
                  break;
              }
            }
        }

        if(entry.ID == 1)
        {
           var filterdata = updatedTimeline.find(item => item.ID == 24);
           if(filterdata != null)
           {
            var reqyear =  filterdata.StartDate;    
            
            // Check for Requirement year
            if(reqyear < "2021" || reqyear  > this.getRequirementMaxYear().toString())
            {
               errormessage = 'Timeline Settings Requirement year must be from 2021 to ' + this.getRequirementMaxYear().toString();
               this.IsValid = false;
               break;
            }

              // Check for StartDate equal and endDate based on requirment year
              if(Date.parse('01-Oct-'+ (parseInt(reqyear)-1).toString()) > Date.parse(entry.StartDate) || Date.parse('31-Dec-'+(parseInt(reqyear)-1).toString()) < Date.parse(entry.StartDate)
              && Date.parse('01-Oct-'+ (parseInt(reqyear)-1).toString()) > Date.parse(entry.EndDate) || Date.parse('31-Dec-'+(parseInt(reqyear)-1).toString()) < Date.parse(entry.EndDate)
              )
              {
                  errormessage = 'Timeline Settings Annual Requirement Submission should  be between 01-Oct-'+(parseInt(reqyear)-1).toString()+' to 31-Dec-'+(parseInt(reqyear)-1).toString();
                  this.IsValid = false;
                  break;
              }
            }
        }
        
      if(entry.ID == 17 || entry.ID == 18 || entry.ID == 19 || entry.ID == 21 || entry.ID == 22
        || entry.ID == 23 )
        {
           // Check for Zero entry for days
             if(entry.StartDate == "0")
             {
                errormessage = 'Timeline Settings days should not be equal to zero.';
                this.IsValid = false;
                break;
             }

             if(entry.StartDate > "365")
             {
                errormessage = 'Timeline Settings days should be equal or less than 365.';
                this.IsValid = false;
                break;
             }
        }
     }
   }
  
    if(!this.IsValid && typeof errormessage!='undefined' && errormessage)
    {
      this.toastr.error(errormessage);
      this.loader = 'none';
    }
    else
    {
     this.timelineConfigurationService.updateTimelineConfiguration(updatedTimeline)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          if (resdata.data[0].status == 'true') {
            this.toastr.success(resdata.data[0].msg);
            this.getTimelineConfiguration();
            this.loader = 'none';
          }
          else {
            this.toastr.error(resdata.data[0].msg);
            this.loader = 'none';
          }
        }
        else {
          this.toastr.error(resdata.data[0].msg);
          this.loader = 'none';
        }
      })
    }
  }
}
